import React, { useState } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
import axios from "axios";
//store
import usePartnerStore from "src/webapp/stores/partner.store";

const useSalesHook = () => {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { partner } = usePartnerStore();

    /* =============== 예약별회원상세내용 =============== */
    const [ profile, setProfile ] = useState({});
    const reservMemberProfileAPI = async(item) => {
        const DATA = { PARTNER_CD:partner.COMN_CD, ORDER_NO:item.ORDER_NO, MEMBER_CD:item.MEMBER_CD };
        const result = await axiosPostHandler(`partnerSalesByMemberProfileForPartner.do`, DATA);
        if(!result || result.message !== "SUCCESS") { return; }
        if(result.message === "SUCCESS") {
            setProfile(result.data);
        }
    }
    /* =============== 예약별회원상세내용 =============== */

    

    /* ===== 매출회원상세 ===== */
    const [ isOpen, setOpen ] = useState(false);
    //팝업off
    const handleDismissChange = (data) => { setOpen(data); }
    //매출별회원예약정보API
    const salesMemberProfileAPI = async (item) => {
        const DATA = { "PARTNER_CD":partner.COMN_CD, "ORDER_NO":item.ORDER_NO, "MEMBER_CD":item.MEMBER_CD };
        axios.post(`${process.env.REACT_APP_BACK_HOST}partnerSalesByMemberProfileForPartner.do`, DATA)
            .catch(err => {console.log("Error >", err); })
            .then(response => {
                const res = response.data;
                if (res.message == "INVALID_REQUEST") { alert("잘못된 요청입니다"); }
                if (res.message == "SUCCESS") { setProfile(res.data); setOpen(true); }
            });
    }
    /* ===== 매출회원상세 ===== */

    return { 
        isOpen, handleDismissChange, salesMemberProfileAPI,//매출회원상세
        reservMemberProfileAPI, profile//예약별회원상세내용
    };
}

export default useSalesHook;